(function () {
  if (window.__productAccordionInit) return;
  window.__productAccordionInit = true;

  var SELECTOR = '.product__info-wrapper .flex-box .title-wrapper';
  var ATC_SELECTOR = '.product-form__submit, [type="submit"][name="add"]';
  var LOCK_MS = 400;
  var blockUntil = 0;

  function isEnterKey(event) {
    return (
      event.key === 'Enter' ||
      event.code === 'Enter' ||
      event.code === 'NumpadEnter' ||
      event.keyCode === 13
    );
  }

  function accordionTriggerFrom(el) {
    return el && el.closest ? el.closest(SELECTOR) : null;
  }

  function shouldBlockCartSubmit() {
    return Date.now() < blockUntil;
  }

  function armCartBlock() {
    blockUntil = Date.now() + 800;
  }

  function toggleAccordion(trigger) {
    var now = Date.now();
    var last = Number(trigger.getAttribute('data-accordion-lock') || 0);
    if (now - last < LOCK_MS) return;
    trigger.setAttribute('data-accordion-lock', String(now));

    var box = trigger.closest('.flex-box');
    if (!box) return;
    var content = box.querySelector(':scope > .content-wrapper') || box.querySelector('.content-wrapper');
    if (!content) return;

    var plus = trigger.querySelector('.icon-plus');
    var minus = trigger.querySelector('.icon-minus');
    var duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200;
    var willExpand = trigger.getAttribute('aria-expanded') !== 'true';

    trigger.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
    if (plus) plus.style.display = willExpand ? 'none' : '';
    if (minus) minus.style.display = willExpand ? '' : 'none';

    if (window.jQuery) {
      var $content = window.jQuery(content);
      if (willExpand) {
        $content.stop(true, true).css('display', 'none').removeAttr('hidden').slideDown(duration);
      } else {
        $content.stop(true, true).slideUp(duration, function () {
          content.setAttribute('hidden', 'hidden');
          content.style.display = '';
        });
      }
      return;
    }

    if (willExpand) {
      content.removeAttribute('hidden');
      content.style.display = 'block';
    } else {
      content.setAttribute('hidden', 'hidden');
      content.style.display = '';
    }
  }

  function activateAccordion(event, trigger) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (event.type === 'keydown') armCartBlock();
    toggleAccordion(trigger);
  }

  window.addEventListener(
    'keydown',
    function (event) {
      if (!isEnterKey(event) && event.key !== ' ') return;

      var trigger = accordionTriggerFrom(event.target);
      if (trigger) {
        activateAccordion(event, trigger);
        return;
      }

      if (!isEnterKey(event)) return;
      if (!event.target.closest || !event.target.closest('.product__info-wrapper, product-info')) return;
      if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      if (event.target.closest(ATC_SELECTOR)) return;
      if (event.target.closest('a[href]:not(' + SELECTOR + ')')) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener(
    'click',
    function (event) {
      var trigger = accordionTriggerFrom(event.target);
      if (trigger) {
        activateAccordion(event, trigger);
        return;
      }

      if (!shouldBlockCartSubmit()) return;
      if (!event.target.closest) return;
      if (event.target.closest(ATC_SELECTOR)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener(
    'submit',
    function (event) {
      if (!shouldBlockCartSubmit() && !accordionTriggerFrom(document.activeElement) && !accordionTriggerFrom(event.submitter)) {
        return;
      }
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    },
    true
  );

  function markFirstLast() {
    document.querySelectorAll('.product__info-wrapper').forEach(function (wrapper) {
      var boxes = wrapper.querySelectorAll('.flex-box');
      boxes.forEach(function (box) {
        box.classList.remove('first', 'last');
      });
      if (boxes[0]) boxes[0].classList.add('first');
      if (boxes.length) boxes[boxes.length - 1].classList.add('last');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markFirstLast);
  } else {
    markFirstLast();
  }
})();
